var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconApple = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 11.8261,
  height: 13.9129,
  viewBox: "0 0 11.8261 13.9129",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons"
}, /*#__PURE__*/React.createElement("path", {
  id: "apple-[#173]",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.04931 2.22113C8.55649 1.63331 8.89837 0.814595 8.80481 0C8.07393 0.0278261 7.18971 0.466885 6.66564 1.05401C6.19504 1.57504 5.78423 2.40758 5.89467 3.20618C6.70996 3.2667 7.54213 2.80964 8.04931 2.22113ZM9.87756 7.3913C9.89795 9.49702 11.805 10.1975 11.8261 10.2065C11.8106 10.2559 11.5215 11.2046 10.8216 12.1855C10.2159 13.0328 9.58774 13.8766 8.598 13.8947C7.62584 13.9121 7.31281 13.3424 6.20067 13.3424C5.08923 13.3424 4.74173 13.8765 3.82163 13.912C2.86636 13.9461 2.1383 12.9953 1.52842 12.1508C0.280511 10.4235 -0.67265 7.26963 0.607612 5.14096C1.24352 4.08428 2.37958 3.41411 3.61341 3.39742C4.5511 3.38003 5.43673 4.00204 6.01004 4.00204C6.58334 4.00204 7.65961 3.25422 8.79074 3.36413C9.26415 3.38291 10.5937 3.54703 11.4469 4.74423C11.378 4.78527 9.86067 5.63133 9.87756 7.3913Z",
  fill: "#FDF8ED"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-apple.ff5eefc6169d386f933604439c11c7d0.svg";